import api from "./axios";

export const checkStripeAccount = async () => {
  try {
    const response = await api.get("/api/v2/payment/check-stripe-account");
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching payment methods."
    );
  }
};
export const checkValidCoupon = async (product, coupon) => {
  try {
    const response = await api.get(
      `/api/v1/customer/payment/check-valid-coupon/${product}/${coupon}`
    );
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching payment methods."
    );
  }
};

export const createSubscriptionsPaymentIntent = async (data) => {
  try {
    const response = await api.post(
      `/api/v2/payment/create-subscriptions-payment-intent`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Error fetching payment methods."
    );
      const message =
      error.response?.data?.message || "Error fetching payment methods.";
    throw {
      ...error,
      message,
    };
   
  }
};

export const paymentIntentConfirmation = async (data) => {
  try {
    const response = await api.post(
      `/api/v2/payment/payment-intent-confirmation`,
      data
    );
    return response.data;
  } catch (error) {
    console.error(
      error.response?.data?.message || "Backend confirmation failed"
    );
  }
};

export const fetchPaymentMethods = async () => {
  try {
    const response = await api.get(`/api/v1/customer/payment/methods`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment methods:", error);
  }
};

export const deletePaymentMethod = async (Id) =>{
  try {
    const response = await api.delete(`/api/v1/customer/payment/methods/${Id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment methods:", error);
  }
}

export const defaultPaymentMethod = async (data) =>{
  try {
    const response = await api.post(`/api/v1/customer/payment/methods/default`,data);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment methods:", error);
  }
}